import { useEffect, useState } from 'react';

import { TapPaymentWidget } from '@/components/atomic/atoms';
import {
  DeliveryInfoMobile,
  GenericKeyValueBox,
  LoginAndPaymentCTA,
  PriceSummary,
  TermsAndConditions
} from '@/components/atomic/molecules';
import { haflaBankDetails } from '@/config/common';
import { GetUiDeviceSurface } from '@/helpers/screenResolutionHelper';
import { parseFormatPriceValueFromAPI } from '@/lib/numberStringUtils';
import { transformDeliveryDetailForMobile } from '@/services/hostCart.service';

const PriceSummaryWithDetailWeb = ({
  disableLoginButton,
  disableProceedToPayment,
  isLoginAndPaymentCTAVisible,
  onClickGeneratePaymentLink,
  onClickLogin,
  onClickProceedToPayment,
  paymentDetail,
  renderTapPaymentWidget,
  setLoading,
  setRenderTapPaymentWidget,
  setShowToast,
  setTapSanitizedToken,
  summaryDetail
}) => (
  <div className='md:w-150 hidden md:flex flex-col gap-4'>
    <PriceSummary
      {...{
        ...summaryDetail,
        disableLoginButton,
        disableProceedToPayment,
        isLoginAndPaymentCTAVisible,
        onClickLogin,
        onClickProceedToPayment,
        renderTapPaymentWidget,
        setLoading,
        setRenderTapPaymentWidget,
        setShowToast,
        setTapSanitizedToken
      }}
    />
    {paymentDetail && (
      <GenericKeyValueBox
        {...{
          boxTitle: 'Payment Info',
          buttonProps: {
            children: 'Pay Now',
            className: `bg-brand-gradient h-12.5 py-4 rounded-md text-white text-base font-medium leading-5 w-full mt-8 ml-auto mb-7 md:mb-0`,
            onClick: onClickGeneratePaymentLink
          },
          keyValuePairList: paymentDetail
        }}
      />
    )}
    <GenericKeyValueBox
      {...{
        boxTitle: 'Company Bank Details',
        keyValuePairList: haflaBankDetails
      }}
    />
  </div>
);

const PriceSummaryWithDetailMobile = ({
  disableLoginButton,
  disableProceedToPayment,
  isLoginAndPaymentCTAVisible,
  onClickGeneratePaymentLink,
  onClickLogin,
  onClickProceedToPayment,
  paymentDetail,
  summaryDetail,
  termsAndConditions,
  setRenderTapPaymentWidget,
  setLoading,
  setShowToast,
  setTapSanitizedToken,
  renderTapPaymentWidget,
  summaryDetail: {
    orderTotal,
    userCart: { email: hostEmail, mobile: hostMobile, name: hostName }
  }
}) => {
  const [isOpen, setIsOpen] = useState(false);
  // TODO: HP - try to apply class using DOM contex provider
  useEffect(() => {
    const addOrRemove = isOpen ? 'add' : 'remove';
    document.body.classList[`${addOrRemove}`]('overflow-hidden');
  }, [isOpen]);

  return (
    <div className='flex gap-4 md:hidden flex-col'>
      <PriceSummary
        {...{
          ...summaryDetail,
          onClickLogin
        }}
      />
      <DeliveryInfoMobile
        {...transformDeliveryDetailForMobile(summaryDetail)}
      />
      {paymentDetail && (
        <GenericKeyValueBox
          {...{
            boxTitle: 'Payment Info',
            buttonProps: {
              children: 'Pay Now',
              className: `bg-brand-gradient h-12.5 py-4 rounded-md text-white text-base font-medium leading-5 w-full mt-8 ml-auto mb-7 md:mb-0`,
              onClick: onClickGeneratePaymentLink
            },
            keyValuePairList: paymentDetail
          }}
        />
      )}
      <TermsAndConditions {...{ termsAndConditions }} />
      <LoginAndPaymentCTA
        {...{
          disableLoginButton,
          disableProceedToPayment,
          isLoginAndPaymentCTAVisible,
          onClickLogin,
          onClickProceedToPayment,
          setIsOpen,
          setRenderTapPaymentWidget
        }}
      />
      {isOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-70 pointer-events-none z-30' />
      )}
      {renderTapPaymentWidget && (
        <div className='fixed left-0 right-0 bottom-0 z-50 flex justify-center items-end bg-transparent'>
          <div className='w-full max-w-md bg-white rounded-t-lg p-4 shadow-xl'>
            <TapPaymentWidget
              {...{
                buttonBackgroundColorClass: 'bg-brand-gradient',
                hostEmail,
                hostMobile,
                hostName,
                onClickPayAmount: onClickProceedToPayment,
                setIsOpen,
                setLoading,
                setRenderTapPaymentWidget,
                setShowToast,
                setTapSanitizedToken,
                showHeader: true,
                textColorClass: 'text-white',
                transactionAmountInUpperDenomination:
                  parseFormatPriceValueFromAPI(orderTotal)
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const PriceSummaryWithDetailOrganism = ({
  disableLoginButton,
  disableProceedToPayment,
  isLoginAndPaymentCTAVisible,
  onClickGeneratePaymentLink,
  onClickLogin,
  onClickProceedToPayment,
  paymentDetail,
  renderTapPaymentWidget,
  setLoading,
  setRenderTapPaymentWidget,
  setShowToast,
  setTapSanitizedToken,
  summaryDetail,
  termsAndConditions
}) => {
  const surface = GetUiDeviceSurface();

  const PriceSummaryDetailMap = {
    mobile: PriceSummaryWithDetailMobile,
    web: PriceSummaryWithDetailWeb
  };

  const PriceSummaryDetail = PriceSummaryDetailMap[surface];

  return (
    <PriceSummaryDetail
      {...{
        disableLoginButton,
        disableProceedToPayment,
        isLoginAndPaymentCTAVisible,
        onClickGeneratePaymentLink,
        onClickLogin,
        onClickProceedToPayment,
        paymentDetail,
        renderTapPaymentWidget,
        setLoading,
        setRenderTapPaymentWidget,
        setShowToast,
        setTapSanitizedToken,
        summaryDetail,
        termsAndConditions
      }}
    />
  );
};

export default PriceSummaryWithDetailOrganism;
